import {Component, OnInit} from '@angular/core';
import {TransportesViagensService} from "./transportes-viagens.service";
import {TransportesViagensModel} from "./transportes-viagens.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-transportes-viagens',
  templateUrl: './transportes-viagens.component.html'
})
export class TransportesViagensComponent extends Components implements OnInit {

  viagens: TransportesViagensModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  pageIsAdd = false;
  pageIsUpd = false;
  id_transporte = '';

  constructor(
    private transportesViagensService: TransportesViagensService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'transportes'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    /*this.transportesViagensService.getPaginacao(1, this.itensPorPagina, ['transporte', 'local_descarga', 'local_carregamento'])
      .subscribe(data => {
        this.viagens = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];

          if (this.global.debug) {
            console.log(this.viagens);
          }
      },
      error => {
        this.func.showErro(error.json());
      });*/

    this.getPage(1);

  }

  delete(viagem) {
    let viagens = this.viagens;
    let transportesViagensService = this.transportesViagensService;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarViagem')+viagem.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(this.global.debug == true){
          console.log(viagens);
        }

        let index = viagens.indexOf(viagem);
        viagens.splice(index, 1);

        transportesViagensService.apagar(viagem.id)
          .subscribe(res => {
              this.navios = viagens;
            },
            err => {
              // Revert the view back to its original state
              viagens.splice(index, 0, viagem);
              this.viagens = viagens;

              this.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.transportesViagensService.getPaginacao(pagina, this.itensPorPagina, ['transporte', 'local_descarga', 'local_carregamento'])
      .subscribe(data => {
        this.viagens = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
      },
      error => {
        this.func.showErro(error.json());
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/transportes-viagens/transportes-viagens.component.ts